import _ from 'lodash'
import dayjs from 'dayjs'
const FMT_1 = 'YYYY-MM-DD HH:mm:ss'
const FMT_2 = 'YYYY-MM-DD'

/**
 * Created by fitz on 2017/6/1.
 */
const dateUtil = {
    /**
     * DateFormat("yyyy-MM-dd hh:mm:ss",strTime) ==> 2016-07-02 08:09:04.423
     * DateFormat("yyyy-M-d h:m:s.S")  ==> 2016-7-2 8:9:4.18
     * @return {string}
     */
    FormatDate(fmt, strTime) {
        let date = new Date(strTime);
        let o = {
            "M+": date.getMonth() + 1,                //月份
            "d+": date.getDate(),                    //日
            "h+": date.getHours(),                   //小时
            "m+": date.getMinutes(),                 //分
            "s+": date.getSeconds(),                 //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (let k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },
    /**
     * 生成一个时间间隔[date1,date2]
     * @param interval  时间间隔
     * @param includeToday 是否包括今天
     */
    getDefaultDate: function (interval, includeToday = false) {
        if (!_.isFinite(interval)) {
            interval = 7;   //如果传的参数不对，就默认时间段一周
        }
        const end = new Date();
        const start = new Date();
        if (!includeToday) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * interval);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
        } else {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (interval - 1));
        }
        return [start, end];
    },
    /**
     * 格式化一个日期
     * @param interval
     * @param fmt
     */
    formatDate(interval = 0, fmt = 'YYYY-MM-DD') {
        const dt = new Date()
        dt.setTime(dt.getTime() - 3600 * 1000 * 24 * interval)
        return dayjs(dt).format(fmt)
    },

    getIntervalDate: function (interval = 7, includeToday = true, fmt = 'YYYY-MM-DD') {
        if (!_.isFinite(interval)) {
            interval = 7;   //如果传的参数不对，就默认时间段一周
        }
        const end = new Date();
        const start = new Date();
        if (!includeToday) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * interval);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
        } else {

            start.setTime(start.getTime() - 3600 * 1000 * 24 * (interval - 1));
        }
        let startDt = dayjs(start).format(fmt)
        let endDt = dayjs(end).format(fmt)
        return [startDt, endDt]
    },

    getTimeArrUntilToday() {
        const now = Date.now()
        let start1 = dayjs(now).format(FMT_2)
        let start = dayjs(start1).format(FMT_1)

        let end = dayjs(start1).add(1, 'day').subtract(1, 'second').format(FMT_1)
        return [start, end]
    },

    /**
     * 获取一个月分范围，包含本月，默认三个月
     * @param interval 默认2
     * @param fmt
     * @return {string[]}
     */
    getIntervalMonth: function(interval = 2, fmt = 'YYYY-MM') {
        if(interval <= 0) {
            interval = 0
        }
        let start = dayjs(new Date()).subtract(interval, 'month').format(fmt)
        let end = dayjs(new Date()).format(fmt)
        return [start, end]
    },

    getIntervalMonthWithNoFormat: function(interval = 2) {
        if(interval <= 0) {
            interval = 0
        }
        let now = this.getCurrentMonthStartTime()
        let start = dayjs(now).subtract(interval, 'month')
        let end = now
        return [start, end]
    },
    getCurrentMonthStartTime: function () {
        let date = new Date()
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return new Date(year +'-'+ month +'-'+ day) // 这里传入的是字符串
    },
    /**
     * 获取一个月分范围，不包含本月，默认三个月
     * @param interval 默认2
     * @param fmt
     * @return {string[]}
     */
    getIntervalMonth1: function(interval = 2, fmt = 'YYYY-MM') {
        if(interval <= 0) {
            interval = 0
        }
        let start = dayjs(new Date()).subtract(interval+1, 'month').format(fmt)
        let end = dayjs(new Date()).subtract(1, 'month').format(fmt)
        return [start, end]
    },
    /**
     * 生成两个时间间隔
     */
    getTwoDefaultDate: function () {
        let twoDate = {};
        //第一个时间段
        const end1 = new Date();
        const start1 = new Date();
        start1.setTime(start1.getTime() - 3600 * 1000 * 24 * 14);
        end1.setTime(end1.getTime() - 3600 * 1000 * 24 * 8);
        twoDate.date1 = [start1, end1];
        //第二个时间段
        const end2 = new Date();
        const start2 = new Date();
        start2.setTime(start2.getTime() - 3600 * 1000 * 24 * 7);
        end2.setTime(end2.getTime() - 3600 * 1000 * 24);
        twoDate.date2 = [start2, end2];
        return twoDate;
    },
    /**
     * 将一个时间段内的日期转分开转换成一个数组，比如：2017-7-1~2017-7-3 ==> ['2017-7-1','2017-7-2','2017-7-3']
     * @param date1
     * @param date2   date1 < date2
     */
    dateRange2Array(date1, date2) {
        if (!(date1 instanceof Date && date1 instanceof Date)) {
            return [];
        }
        let fmt = "yyyy-MM-dd";
        let firstDate = this.FormatDate(fmt, date1);
        let firstDateSplit = firstDate.split('-');
        let firstDay = Number(firstDateSplit[2]);

        let lastDate = this.FormatDate(fmt, date2);
        let lastDateSplit = lastDate.split('-');
        let lastDay = Number(lastDateSplit[2]);

        let dayArray = [];
        for (let i = 0; firstDay + i < lastDay; i++) {
            let str1 = firstDateSplit[0] + "-" + firstDateSplit[1] + "-";
            dayArray.push(str1 + (firstDay + i))
        }
        dayArray.push(lastDate);
        return dayArray;
    },
    /**
     * 将一个时间段内的日期转换成一个月度数组，比如：2021-01~2021-03 ==> ['2021-01-01','2021-02-01','2021-03-01']
     * @param date1
     * @param date2   date1 < date2
     */
    dateRange2MonthArray(date1, date2) {
        /*if (!(date1 instanceof Date && date1 instanceof Date)) {
            return [];
        }*/
        let fmt = "yyyy-MM";
        let firstDate = this.FormatDate(fmt, date1);
        let firstDateSplit = firstDate.split('-');
        let firstYear = Number(firstDateSplit[0]);
        let firstMonth = Number(firstDateSplit[1]);

        let lastDate = this.FormatDate(fmt, date2);
        let lastDateSplit = lastDate.split('-');
        let lastYear = Number(lastDateSplit[0]);
        let lastMonth = Number(lastDateSplit[1]);

        let dayArray = [];
        for(let y = 0; firstYear + y <= lastYear; y++){
            console.log(y)
            let  tempFirstMonth = firstMonth;
            let  tempLastMonth = lastMonth;
            if(y===0 && firstYear < lastYear){
                tempLastMonth = 13;
            }else if(y >0 && (firstYear+y) < lastYear){
                tempFirstMonth = 1;
                tempLastMonth = 13;
            }else if(y >0 && (firstYear+y) === lastYear){
                tempFirstMonth = 1;
            }
            for (let i = 0; tempFirstMonth + i < tempLastMonth; i++) {
                let str1 = ""+ (firstYear + y) + "-";
                if((tempFirstMonth+i) <= 9){
                    str1 = str1+"0";
                }
                dayArray.push(str1 + (tempFirstMonth + i) + "-01")
            }
        }
        dayArray.push(lastDate+ "-01");
        return dayArray;
    },
    dateArr2ChinaFormat(dateArr){
        let dateResult = {};
        dateArr.forEach(item =>{
            let temp = item.substring(0,7);
            let teSplit = temp.split("-");
            dateResult[item] = teSplit[0] + "年" + teSplit[1] + "月"
        })
        return dateResult;
    },
    getCurrentMonth() {
        return dayjs().month()
    },
    /**
     *
     * @param dt1 '2020-1-15' | new Date()
     * @param dt2 '2020-1-15' | new Date()
     * @return {boolean}
     */
    judgeMonthEquals(dt1, dt2) {
        return dayjs(dt1).month() === dayjs(dt2).month()
    },
    judgeYearEquals(dt1, dt2) {
        return dayjs(dt1).year() === dayjs(dt2).year()
    }

};
export default dateUtil
